import React, { useEffect } from 'react';
import useScreenSize from 'Hooks/useScreenSize';
import classNames from 'classnames';
import { capitalize } from 'lodash';

const CourseSelectionNotice = () => {
	const isMobile = useScreenSize();

	const [expanded, setExpanded] = React.useState(false);

	useEffect(() => {
		if (!isMobile) {
			setExpanded(true);
		}
	}, [isMobile]);

	return (
		<>
			<span className="icon icon-only icon-info" aria-label="selection warning icon" role="alert" />
			<p className="notice-title">{capitalize(window.lexicon.selectionNotice)}</p>
			{ expanded && <p className="notice-message">{capitalize(window.lexicon.selectionNoticeText)}</p>}
			{ isMobile && (
				<span
					aria-label="course-selection-notice"
					tabIndex={0}
					className={classNames(
						'expand-btn icon icon-only',
						{
							'icon-keyboard-arrow-down': !expanded,
							'icon-remove': expanded,
						},
					)}
					onClick={() => setExpanded(!expanded)}
					onKeyDown={() => setExpanded(!expanded)}
					role="button"
				/>
			)}
		</>
	);
};

export default CourseSelectionNotice;
